import { ERPAdapter } from "@sia/style-guide";
import keycloakIDPAdapter from "common/Adapters/IDPAdapter/KeycloakIDPAdapter";

const apiUrl = process.env.REACT_APP_ERP_API_URL;
const newApiUrl = process.env.REACT_APP_NEW_ERP_API_URL;

const erpAdapter = new ERPAdapter(keycloakIDPAdapter, apiUrl, newApiUrl);
export default erpAdapter;
